export default "__VITE_PUBLIC_ASSET__5af5fe16__"